export enum OpportunityActionTypes {
  SET_OPPORTUNITY = "SET_OPPORTUNITY",
  SET_OPPORTUNITY_FIELD = "SET_OPPORTUNITY_FIELD",
  SET_COMPLETE_OPPORTUNITY = "SET_COMPLETE_OPPORTUNITY",
  SET_OPPORTUNITY_UNIQUE = "SET_COMPLETE_OPPORTUNITY_UNIQUE",
}
